import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/supabase.config';

interface RefreshResult {
  success: boolean;
  message: string;
  refreshed_at: string;
  duration_ms: number;
}

async function refreshDashboardViews(): Promise<RefreshResult> {
  const { data, error } = await supabase.rpc('trigger_dashboard_refresh');
  
  if (error) {
    throw new Error(error.message);
  }
  
  return data as unknown as RefreshResult;
}

/**
 * Hook to manually refresh dashboard materialized views
 * Use this when you need to force a refresh of the dashboard data
 * (e.g., after bulk operations, or when user clicks a "Refresh" button)
 */
export function useRefreshDashboard() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: refreshDashboardViews,
    onSuccess: (data) => {
      // Invalidate the dashboard cache to refetch with new data
      queryClient.invalidateQueries({ queryKey: ['dashboardStats'] });
      
      console.log('Dashboard refreshed:', data);
      console.log(`Refresh took ${data.duration_ms}ms`);
    },
    onError: (error) => {
      console.error('Failed to refresh dashboard:', error);
    },
  });
}
